export default __webpack_public_path__ + "static/media/(1).fdcd2eb8.jpg";